module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_kristianstad-f2afac18c65fc5cdf177099c3d6a09fb.png";